import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableSearchComponent } from './table-search.component';
import { TypeaheadIeFixModule } from '@schoolbelle/shared/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [TableSearchComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    TypeaheadIeFixModule.forRoot(),

  ],
  exports: [TableSearchComponent],
})
export class TableSearchModule { }
